import { render, staticRenderFns } from "./MyTickerStatus.vue?vue&type=template&id=729c5690&scoped=true"
import script from "./MyTickerStatus.vue?vue&type=script&lang=js"
export * from "./MyTickerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c5690",
  null
  
)

export default component.exports